export default __webpack_public_path__ + "images/355fe8a0b3953d28e181c7bce5fec587.svg";